import { type ResourceId } from '@app/client';
import { type EmojiId } from '@app/client/common/structs/emoji/emoji';
import { type GroupItemNFT, type ISODate, type Tier } from '@app/client/common/structs/groups/groups';
import { type SocialGroup } from '@app/gen';

export enum WebsocketTopic {
    // App Release
    AppRelease = 'AppRelease',
    // Generic Notifications
    Notification = 'Notification',
    // Orders
    OrderUpdated = 'OrderUpdated',
    // Transfers
    EmojiTransferRequestAccepted = 'EmojiTransferRequestAccepted',

    //Free Yats
    FreeYatAssigned = 'FreeYatAssigned',
    // User
    WalletConnected = 'WalletConnected',
    WaitlistSizeChanged = 'WaitlistSizeChanged',
    GemMintedQuantityChanged = 'GemMintedQuantityChanged',
    // NFTs (New Yat)
    MultipleNftsAdded = 'MultipleNftsAdded',
    MultipleNftsRemoved = 'MultipleNftsRemoved',
    NftAdded = 'NftAdded',
    NftRemoved = 'NftRemoved',
    GroupNftAdded = 'GroupNftAdded',

    GroupSubscription = 'group-',

    // Fantasy
    CompetitionSubmissionChange = 'CompetitionSubmissionChange',
    CompetitionLineupUpdated = 'CompetitionLineupUpdated',
    CompetitionWishlistChanged = 'CompetitionWishlistChanged',
}

export enum WebsocketLevel {
    /// The "error" level.
    ///
    /// Designates very serious errors.
    Error = 'Error',
    /// The "warn" level.
    ///
    /// Designates hazardous situations.
    Warn = 'Warn',
    /// The "info" level.
    ///
    /// Designates useful information.
    Info = 'Info',
    /// The "debug" level.
    ///
    /// Designates lower priority information.
    Debug = 'Debug',
    /// The "trace" level.
    ///
    /// Designates very low priority, often extremely verbose, information.
    Trace = 'Trace',
}

export interface WebsocketPayload<T> {
    action_id: ResourceId;
    data?: T;
    level: WebsocketLevel;
    message?: string;
}

type G = NonNullable<SocialGroup['items']>[number];
export type WebsocketGroupItem = Omit<G['item'], 'item_type'> & {
    item_type: {
        Nft: GroupItemNFT;
    };
    metadata_complete: boolean;
    spam: boolean;
    owner_address: string;
    contract_address: string;
    status: string;
    activity_date: ISODate;
    created_at: ISODate;
    updated_at: ISODate;
    tier?: Tier;
};

export interface WebsocketPodData {
    item: WebsocketGroupItem;
    owner?: {
        member_id: ResourceId;
        user_id: ResourceId;
        twitter?: string;
        primary_yat?: EmojiId;
    };
    visibility?: string;
    topic?: WebsocketTopic;
}

export interface WebsocketMessage<T = unknown> {
    payload: WebsocketPayload<T>;
    topic: string;
}

export interface WebsocketMessageFlatPayload<T = unknown> extends Omit<WebsocketMessage<T>, 'payload'> {
    payload: T;
    result?: { status: string; topic: string };
}
